import type { ClientType, TransformToCamel } from "@/utils/types"
import type { articlesConfig } from "@/state/articlesStore/articlesСonfig"
import type { casesConfig } from "@/state/casesStore/casesConfig"
import type { documentsConfig } from "@/state/documentsStore/documentsConfig"
import type { goalsConfig } from "@/state/goalsStore/goalsStoreConfig"
import type { programDetailConfig } from "@/state/programlDetailStore/programlDetailConfig"
import type { targetsConfig } from "@/state/targetsStore/targetsConfig"

import type {
  Goal,
  Article,
  CaseDetail,
  Target,
  Document,
  GoalForTarget,
  FileModel,
  Brand,
  Program,
} from "../backend"
import type { RouteComponentProps } from "@reach/router"
import type { PaginatedResponse } from "@/api/types/apiTypes"
import { Promotion } from "../backend"

export enum Lang {
  ru = "ru",
  en = "en",
}

// Client типы для основных сущностей
export type ClientGoal = ClientType<Goal, typeof goalsConfig.fieldsToTranslate>
export type ClientProgram = ClientType<
  Program,
  typeof programDetailConfig.fieldsToTranslate
>
export type ClientArticle = ClientType<
  Article,
  typeof articlesConfig.fieldsToTranslate
>

export type ClientCaseDetail = ClientType<
  CaseDetail,
  typeof casesConfig.fieldsToTranslate
>

export type ClientDocument = ClientType<
  Document,
  typeof documentsConfig.fieldsToTranslate
>
export type ClientGoalForTarget = TransformToCamel<GoalForTarget> & {
  name?: string
}

export type ClientTarget = ClientType<
  Target,
  typeof targetsConfig.fieldsToTranslate
>

export type ClientBrand = ClientType<Brand>

export type ResultQuery<T> = { result: T }

export type GoalQueryResult = ResultQuery<ClientGoal[]>

export type ProgramQueryResult = ResultQuery<ClientProgram[]>

export type Format = {
  id: number
  title: string
}

export type ClientFileModel = ClientType<FileModel, ["file", "name"]>
export interface PagePreviewProps extends RouteComponentProps<{
  slug: string
}> {
  lang: Lang
}

export type MetaOptions = {
  metaDescription: string
  metaDescriptionEn: string
  metaDescriptionRu: string
  metaImageEn: string
  metaImageRu: string
  metaImage: string
  metaKeywords: string
  metaKeywordsEn: string
  metaKeywordsRu: string
  metaTitle: string
  metaTitleEn: string
  metaTitleRu: string
}

export type ArticlesPages = PaginatedResponse<ClientArticle>

export type MainPageCases = PaginatedResponse<ClientCaseDetail>

export type GoalsPages = PaginatedResponse<ClientTarget>

export type ProgramsPages = PaginatedResponse<ClientProgram>

export type DocumentsPages = PaginatedResponse<ClientDocument>

export type CasesPages = PaginatedResponse<ClientCaseDetail>

export type CaseDetailCasesList = PaginatedResponse<ClientCaseDetail>

export type TargetsPages = PaginatedResponse<ClientTarget>

export interface PartnerLocationCityList {
  /** City */
  city?: string | null
  /** Partners count */
  partnersCount?: string | null
}

export interface PartnerLocation {
  /** ID */
  id?: number
  /** Full address */
  fullAddress?: string | null
  /** City name */
  city?: string | null
  /** Street name */
  street?: string | null
  /** Building number */
  building?: string | null
  /** Latitude */
  latitude?: string | null
  /** Longitude */
  longitude?: string | null
}

export interface Partner {
  /** ID */
  id?: number
  /** Organization title */
  title: string
  /** Email */
  email: string
  /** Phone number */
  phoneNumber?: string | null
  /** Description */
  description: string
  /** Locations */
  locations: PartnerLocation[]
}

export interface RecyclingType {
  /** ID */
  id?: number
  /** Recycling type title */
  title: string
  /** Count of partners */
  count?: number
  /** Partners list */
  partners: Partner[]
}

export interface PartnersResponse {
  /** Total partner points count */
  partnerPointsCount: number
  /** Recycling types list */
  recyclingTypes: RecyclingType[]
}

export interface PromotionResponse {
  promotionsPointsCount: number
  promotions: TransformToCamel<Promotion>[]
}

export interface PromotionLocationCityList {
  /** City */
  city?: string
  /** Promotions count */
  promotionsCount?: number
}
